import helper from '@/libs/forms';


export default {
  fields: [
    helper.simpleInput('text', 'Type', null, 'type', true),
    helper.simpleInput('text', 'Payable to', null, 'receiver', true),
    helper.currency('Amount', 'amount', true, 6),
    helper.date('Due Date', null, 'dueDate', true, 6),
    helper.simpleInput(
      'text', 'To what property (if any) a tax lien attaches', null, 'attachedProperty', true,
    ),
  ],
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/liabilities/schemas/unpaidTaxes.js